import { Component, OnInit } from '@angular/core';

import { UserblockService } from './userblock.service';
import { Adal4Service } from 'adal-angular4';

@Component({
    selector: 'app-userblock',
    templateUrl: './userblock.component.html',
    styleUrls: ['./userblock.component.scss']
})
export class UserblockComponent implements OnInit {
    user: any;
    user_picture: string;
    constructor(public userblockService: UserblockService, public adalService: Adal4Service) {

        this.user = this.adalService.userInfo.profile;
        this.user_picture = '../../../assets/img/img_profile_generic.png';
    }

    ngOnInit() { }

    userBlockIsVisible() {
        return this.userblockService.getVisibility();
    }

}



// WEBPACK FOOTER //
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/app/layout/sidebar/userblock/userblock.component.ts